export const ALL_VARIABLE_VALUE = '$__all';
